import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, FormGroup, Input, Button } from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
import { UncontrolledAlert } from 'reactstrap';
import { AccountActions } from '../../../actions';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      message: '',
      loading: false,
      success: false,
    };
  }

  handleChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        message: '',
      },
      () => {
        this.props.login({
          data: {
            username: encodeURIComponent(this.state.email),
            password: this.state.password,
          },
          cb: (res) => {
            if (res.message) {
              this.setState({
                message: "Nom d'utilisateur ou mot de passe incorrect",
                loading: false,
              });
            } else {
              this.setState({
                message: '',
                loading: false,
              });

              localStorage.setItem('accessToken', res.access_token.accessToken);
              localStorage.setItem('refreshToken', res.access_token.refreshToken);
              localStorage.setItem('userId', res.access_token.userId);
              localStorage.setItem('expired_at', res.access_token.expired_at);

              this.setState({
                success: true,
              });
            }
          },
        });
      }
    );
  };

  render() {
    if (localStorage.getItem('accessToken')) {
      return <Redirect to={'/app/report'} />;
    }

    const { intl } = this.props;
    const { email, password, message, loading, success } = this.state;
    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header mb-4 text-center">
            <Link className="app-logo" to="/" title="BeDaddy">
              <img src="images/logo.png" alt="BeDaddy" title="BeDaddy" />
            </Link>
          </div>

          <div className="login-form">
            <Form onSubmit={this.handleSubmit}>
              <FormGroup className="mb-4">
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={this.handleChange}
                  required
                  placeholder={intl.formatMessage({ id: 'pages.contact.email' })}
                />
              </FormGroup>
              <FormGroup className="mb-4">
                <Input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={this.handleChange}
                  required
                  placeholder={intl.formatMessage({ id: 'pages.account.password' })}
                />
              </FormGroup>
              <div className="mt-1 mb-2 d-flex justify-content-between align-items-center">
                <div className="custom-control custom-checkbox d-flex align-items-center">
                  <input type="checkbox" className="custom-control-input pointer" id="customCheck1" />
                  <label className="custom-control-label" htmlFor="customCheck1">
                    <IntlMessages id="appModule.rememberMe" />
                  </label>
                </div>

                <Link to="/forgot" title="Reset Password">
                  <IntlMessages id="appModule.forgotPassword" />
                </Link>
              </div>

              <div className="loginbtn-wrapper">
                {loading && (
                  <div className="loading">
                    <svg className="circular" viewBox="25 25 50 50">
                      <circle
                        className="path"
                        cx="50"
                        cy="50"
                        r="15"
                        fill="none"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                      ></circle>
                    </svg>
                  </div>
                )}
                <Button className="jr-btn btn-primary btn btn-default" disabled={loading}>
                  <IntlMessages id="appModule.signIn" />
                </Button>
              </div>
              {message && <UncontrolledAlert className="bg-danger text-white shadow-lg">{message}</UncontrolledAlert>}
            </Form>
          </div>
        </div>

        {success && <Redirect to="/app/report" />}
      </div>
    );
  }
}

Login.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
  return {
    userData: state.AccountReducer.userData,
    error: state.AccountReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (req) => dispatch(AccountActions.login(req.data, req.cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Login));



// WEBPACK FOOTER //
// ./app/routes/Login/index.js